import React, {FC, ReactElement, ReactNode} from 'react';
import cn from 'classnames';
import {Popover, Whisper} from 'rsuite';


import {isTranslate} from 'shared/lib/lang';

import styles from './Hint.module.scss';

import type {WhisperProps} from 'rsuite';

export type HintPlacement =
    | 'top' | 'top-start' | 'top-end'
    | 'bottom' | 'bottom-start' | 'bottom-end'
    | 'left' | 'left-start' | 'left-end'
    | 'right' | 'right-start' | 'right-end';

const placementMap: Record<HintPlacement, WhisperProps['placement']> = {
    top: 'top',
    'top-start': 'topStart',
    'top-end': 'topEnd',
    bottom: 'bottom',
    'bottom-start': 'bottomStart',
    'bottom-end': 'bottomEnd',
    left: 'left',
    'left-start': 'leftStart',
    'left-end': 'leftEnd',
    right: 'right',
    'right-start': 'rightStart',
    'right-end': 'rightEnd',
};

interface IHintProps {
    children: ReactNode,
    trigger: ReactElement,
    placement?: HintPlacement,
    className?: string,
}

const getTextLength = (node: ReactNode): number => {
    if (node === null || node === undefined || typeof node === 'boolean') return 0;
    if (typeof node === 'string' || typeof node === 'number') return String(node).length;
    if (Array.isArray(node)) return node.reduce<number>((sum, child) => sum + getTextLength(child), 0);
    if (React.isValidElement(node)) return getTextLength((node.props as {children?: ReactNode}).children);
    return 0;
};

const Hint: FC<IHintProps> = ({children, trigger, placement, className}) => {
    const textLength = getTextLength(children);

    const speaker = (
        <Popover
            className={cn(
                styles.popover,
                className,
                isTranslate() ? styles.enColorLink : '',
            )}
        >
            <div className={cn(styles.initial, textLength > 350 ? styles.hint : '')}>
                {children}
            </div>
        </Popover>
    );

    return (
        <Whisper
            placement={placementMap[placement ?? 'top']}
            trigger="hover"
            speaker={speaker}
            enterable
        >
            {trigger}
        </Whisper>
    );
};

export default Hint;
